<template>
  <span
    role="status"
    :class="['inline-block px-2 py-0.5 rounded-full text-xs font-medium', variantClasses[type] || variantClasses.info]">
    {{ text }}
  </span>
</template>

<script setup lang="ts">
const props = defineProps<{
  /** One of: 'info' | 'accent' | 'success' */
  type: "info" | "accent" | "success";
  text: string;
}>();

const variantClasses: Record<string, string> = {
  info: "bg-blue-100 text-blue-800",
  accent: "bg-yellow-100 text-yellow-800",
  success: "bg-green-100 text-green-800",
};
</script>

<style scoped>
/* nothing extra; colors come from your Tailwind theme */
</style>
